module.exports = __webpack_public_path__ + "static/media/vg.66607bf8.svg";